import { EventEmitter, Directive, Output, HostListener } from '@angular/core';
import { ModalService } from '../services/modal.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ConfirmationModalComponent } from '../components/confirmation-modal.component';

@Directive({
  selector: '[confirm]',
})
export class ConfirmDirective {
  @Output()
  public confirm = new EventEmitter<any>();
  public subscription: Subscription;

  constructor(private readonly sharedModalService: ModalService, private readonly modalService: NgbModal) {}

  @HostListener('click')
  public onClick() {
    this.open();
  }

  public open() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.modalService.open(ConfirmationModalComponent, { centered: true, size: 'lg' });

    this.subscription = this.sharedModalService.yesNoModalClosed.subscribe((success: boolean) => {
      success ? this.confirm.emit() : this.subscription.unsubscribe();
    });
  }
}
